module.exports = __webpack_public_path__ + "static/media/iqra1.9539911c.jpg";